// extracted by mini-css-extract-plugin
export default {"wrapper":"Signup_wrapper__qozLb","inner":"Signup_inner__D4ox8","benefit":"Signup_benefit__yGM2E","signup":"Signup_signup__ZPH8w","cancel-btn":"Signup_cancel-btn__4pWX7"};